// extracted by mini-css-extract-plugin
export default {"workflowList":"workflows-list_workflowList__ujOKp","workflowGroupHeader":"workflows-list_workflowGroupHeader__dqf30"};